import { gql } from '../../../apollo/__generated__';

export const CREATE_MILESTONE = gql(`
  mutation CreateMilestone($createMilestoneInput: CreateMilestoneInput!) {
    createMilestone(createMilestoneInput: $createMilestoneInput) {
      id
      name
      noAlcoholDiscount
      bedroomValue
      prices {
        day
        value
      }
      startAt
      endAt
    }
  }
`);
